<template>
  <game-template title="Choisissez l’action la plus appropriée à chacune des étapes de départ d’un collaborateur">
    <template v-slot:content>
      <image-quizz :steps="steps"
        @next="next"
        @answer="setAnswer"
        image="depart"
        button-label="Continuer"
        last-step-message="Vous avez su faire les bons choix pour gérer le départ d’un collaborateur.">
      </image-quizz>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import ImageQuizz from '../components/ImageQuizz'

export default {
  name: 'DepartureGame',
  mixins: [stepMixin],
  components: {
    ImageQuizz
  },
  data () {
    return {
      steps: [
        {
          name: 'step-initial',
          question: 'Vous avez un nouveau mail !',
          goodAnswer: 'a',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je l\'ouvre',
              explanation: '<strong>Bon réflexe !</strong><br/>Les éléments doivent rapidement être transmis en paie.'
            },
            {
              name: 'b',
              label: 'Encore un mail !',
              explanation: 'Laissez-le de côté 24h le temps de gérer vos urgences, mais les mails en provenance du service RH doivent être consultés dans les meilleurs délais.'
            }
          ]
        },
        {
          name: 'step-mail',
          question: 'Ok, je dois initialiser le départ de David...',
          goodAnswer: 'b',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je m\'en occuperai à la prochaine clôture',
              explanation: 'Le solde de tout compte doit être fait dans un délai court, il est important de remonter rapidement les informations aux équipes Paie.'
            },
            {
              name: 'b',
              label: 'Je fais le point avec David sur ses absences et heures excédentaires',
              explanation: '<strong>Effectivement,</strong><br>pour éviter d\'oublier des éléments de paie, faites le point avec le collaborateur sur ses absences, primes et heures jusqu\'à la date de son départ. La totalité des éléments (passés et à venir) doit être prise en compte.'
            },
            {
              name: 'c',
              label: 'De David ? J\'ai un David dans l\'équipe ?',
              explanation: 'Vérifiez sinon l\'email ne vous était peut-être pas destiné.'
            }
          ]
        },
        {
          name: 'step-depart',
          question: 'Point avec David fait !',
          goodAnswer: 'a',
          answer: '',
          answers: [
            {
              name: 'a',
              label: 'Je saisis tous les éléments sur la GTA',
              explanation: '<strong>Bien vu !</strong><br>La paie récupère les informations et sortira le solde de tout compte. ' +
                'Pensez à remonter par email les éléments non gérés en GTA : certaines primes ou éléments variables."'
            },
            {
              name: 'b',
              label: 'Je fais un mail à la RH avec les éléments du solde de tout compte',
              explanation: 'La plupart des élements sont à saisir directement en GTA pour que la paie récupère les informations et sorte le solde de tout compte. Seules certaines primes devront être indiquées par email.'
            }
          ]
        }
      ]
    }
  },
  methods: {
    setAnswer (answer) {
      this.steps.find(step => step.name === answer.step).answer = answer.value
    }
  }
}
</script>

<style lang="scss">

</style>
